import React, { useState, useRef, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import classes from './styles.module.css';

function Status({ currentStatus, setCurrentStatus, isDisabled }) {
    const [isOpened, setIsOpened] = useState(false);

    const status = {
        id: currentStatus,
        name: null,
        color: null,
    };

    switch (currentStatus) {
        case -1:
            status.name = <FormattedMessage id="AccountEditing.status.inactive" defaultMessage="Не активна" />;
            status.color = '#ff9900';
            break;
        case -2:
            status.name = <FormattedMessage id="AccountEditing.status.closed" defaultMessage="Закрыт" />;
            status.color = '#d4d4d4';
            break;
        case -3:
            status.name = <FormattedMessage id="AccountEditing.status.blocked" defaultMessage="Заблокирован" />;
            status.color = 'rgb(220, 57, 18)';
            break;
        case 1:
            status.name = <FormattedMessage id="AccountEditing.status.active" defaultMessage="Активен" />;
            status.color = 'rgb(16, 150, 24)';
            break;
        default:
            status.name = <FormattedMessage id="AccountEditing.status.active" defaultMessage="Активен" />;
            status.color = 'rgb(16, 150, 24)';
    }

    const statusWrap = useRef(null);
    const statusSelect = useRef(null);

    function onStatusClick() {
        setIsOpened(!isOpened);
    }

    function onselectStatus(id) {
        setCurrentStatus(id);
        setIsOpened(false);
    }

    function handleClickOutside(e) {
        if (!!statusWrap.current && !statusWrap.current.contains(e.target)) {
            setIsOpened(false);
        } else if (!!statusSelect.current && !!statusSelect.current.contains(e.target)) {
            setIsOpened(true);
        }
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    });

    return (
        <div ref={statusWrap} className={classes.Status}>
            <div
                onClick={() => {
                    !isDisabled && onStatusClick();
                }}
                className={classes.CurrentStatus}
                style={{ backgroundColor: status.color }}
            >
                {status.name}
            </div>

            {isOpened && (
                <ul ref={statusSelect} className={classes.StatusSelect}>
                    <li style={status.id === 1 ? { fontWeight: 'bold' } : null} onClick={() => onselectStatus(1)}>
                        <FormattedMessage id="AccountEditing.status.active" defaultMessage="Активен" />
                    </li>
                    <li style={status.id === -1 ? { fontWeight: 'bold' } : null} onClick={() => onselectStatus(-1)}>
                        <FormattedMessage id="AccountEditing.status.inactive" defaultMessage="Не активна" />
                    </li>
                    <li style={status.id === -2 ? { fontWeight: 'bold' } : null} onClick={() => onselectStatus(-2)}>
                        <FormattedMessage id="AccountEditing.status.closed" defaultMessage="Закрыт" />
                    </li>
                    <li style={status.id === -3 ? { fontWeight: 'bold' } : null} onClick={() => onselectStatus(-3)}>
                        <FormattedMessage id="AccountEditing.status.blocked" defaultMessage="Заблокирован" />
                    </li>
                </ul>
            )}
        </div>
    );
}

export default Status;



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/AccountEditing/Status.js